/**
 * Size guide link ("Maßangaben")
 *
 * Scrolls to and opens the size guide content. The target is matched by heading
 * text (data-target-heading) against, in order of priority:
 * 1. A tab in the Product Details section (desktop tabs).
 * 2. A collapsible (details-disclosure) in the Main Product or Product Details section.
 *
 * Uses one delegated listener so it survives variant-picker DOM replacements.
 */
if (!window.sizeGuideLinkInitialized) {
  window.sizeGuideLinkInitialized = true;

  document.addEventListener('click', (evt) => {
    const link = evt.target.closest('.js-size-guide-link');
    if (!link) return;

    const heading = (link.dataset.targetHeading || '').trim().toLowerCase();
    if (!heading) return;

    const matchesHeading = (el) => el && el.textContent.trim().toLowerCase().includes(heading);

    // Desktop: horizontal tab in the Product Details section
    const tab = Array.from(document.querySelectorAll('.cc-product-details [role="tab"]'))
      .find((el) => matchesHeading(el) && el.offsetParent !== null);
    if (tab) {
      evt.preventDefault();
      tab.click();
      tab.closest('tabbed-content').scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    // Mobile / collapsible style: details-disclosure matched by its title
    const disclosure = Array.from(document.querySelectorAll('.cc-main-product details-disclosure, .cc-product-details details-disclosure'))
      .find((el) => {
        const title = el.querySelector('.disclosure__title');
        const details = el.querySelector('details');
        return matchesHeading(title) && details && details.offsetParent !== null;
      });
    if (disclosure) {
      evt.preventDefault();
      const details = disclosure.querySelector('details');
      if (!details.open) {
        if (typeof disclosure.open === 'function') {
          disclosure.open();
        } else {
          details.open = true;
        }
      }
      disclosure.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
}
